import clsx from 'clsx';
import React, { useState, useRef, useEffect } from 'react';

import { EditableText } from '../editable-text/editable-text';

import styles from './report-title.scss';
import { useReportBuilderContext } from '../../report-builder.context';
import { ScreenReadersPageTitle } from '@futrli/ui-components';

const UPDATE_NAME_DELAY_TIME = 3000;

interface Props {
  disableEdit?: boolean;
}
export const ReportTitle = ({ disableEdit }: Props) => {
  const {
    reportTitle,
    updateReportTitle,
    pageSetup: { orientation },
    getPageWidth,
    setIsAutoSaving,
    setIsEditingTitle
  } = useReportBuilderContext();
  const [reportName, setReportName] = useState(reportTitle);
  const updateReportTitleTimer = useRef<number | null>(null);

  useEffect(() => {
    if (updateReportTitleTimer.current) {
      clearTimeout(updateReportTitleTimer.current);
    }
    setIsAutoSaving(reportName !== reportTitle && !!reportName.length);
    updateReportTitleTimer.current = (setTimeout(() => {
      if (reportName !== reportTitle && reportName.length) {
        updateReportTitle(reportName);
      }
    }, UPDATE_NAME_DELAY_TIME) as unknown) as number;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportName]);

  useEffect(() => {
    setReportName(reportTitle);
  }, [reportTitle]);

  return (
    <>
      <ScreenReadersPageTitle>{reportName}</ScreenReadersPageTitle>
      <h2 className={clsx(styles.reportTitle)} style={{ width: orientation === 'dashboard' ? 'auto' : getPageWidth() }}>
        {disableEdit ? (
          reportName
        ) : (
          <EditableText
            text={reportName}
            onTextChange={setReportName}
            initialText={reportTitle}
            setIsEditing={setIsEditingTitle}
          />
        )}
      </h2>
    </>
  );
};
